<template>
  <div>
    <div class="page-body">
      <div style="display: flex; justify-content: space-between">
        <div>
          <el-form
            :inline="true"
            class="demo-form-inline"
            label-position="right"
            label-width="100px"
            :model="searcheForm"
          >
            <el-form-item label="选择站点:" prop="stationId">
              <el-select
                style="width: 85%"
                v-model="searcheForm.stationId"
                placeholder="请选择"
                @change="stationIdChange"
              >
                <el-option
                  v-for="item in stationIdOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="设备类型:" prop="equipmentType">
              <el-select
                v-model="searcheForm.equipmentType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in equipmentTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="桩号:">
              <el-input
                placeholder="请输入桩号"
                clearable
                width="200px"
                v-model="searcheForm.equipmentCode"
              ></el-input>
            </el-form-item>
            <el-form-item label="名称:">
              <el-input
                placeholder="请输入桩名称"
                clearable
                width="200px"
                v-model="searcheForm.equipmentName"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="创建日期:"
              label-width="300"
              style="display: none"
            >
              <el-date-picker
                v-model="searcheForm.createTime"
                clearable
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
              <!-- <el-input placeholder="请输入手机号" clear width="180px" v-model="searcheForm.phone"></el-input> -->
            </el-form-item>
            <el-form-item label="更新日期:" style="display: none">
              <el-date-picker
                v-model="searcheForm.updateTime"
                clearable
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
              <!-- <el-input placeholder="请输入地址" clear width="180px" v-model="searcheForm.name"></el-input> -->
            </el-form-item>
            <el-button
              icon="el-icon-search"
              type="primary"
              @click="search"
              >搜索</el-button
            >

            &nbsp;&nbsp;

            <el-button icon="el-icon-search" type="primary" @click="clearForm"
              >清除</el-button
            >
          </el-form>
        </div>
        <div>
          <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView"
            >新增</el-button
          >
        </div>
      </div>
    </div>
    <!-- 表格 start -->
    <div style="margin-top: 30px">
      <el-table
        :data="users"
        stripe
        border
        v-loading="loading"
        element-loading-text="正在加载..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <el-table-column
          prop="equipmentName"
          label="名称"
          fixed
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="equipmentCode"
          label="桩号"
          width="200"
          align="center"
          fixed=""
        ></el-table-column>

        <el-table-column
          prop="stationName"
          label="站点名称"
          width="200"
          align="center"
          fixed=""
        ></el-table-column>
        <el-table-column
          prop="equipmentType"
          label="设备类型"
          width="100"
          align="center"
          :formatter="formatEquipmentType"
        ></el-table-column>
        <el-table-column
          prop="gatewayName"
          label="网关"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.equipmentType == 1"> -无- </span>
            <span v-if="scope.row.equipmentType == 2">
              {{ scope.row.gatewayName }}/{{ scope.row.remoteGatewaySn }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="qrcodeImgUrl"
          label="二维码"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            <div style="width: 70px; height: 70px; display: inline">
              <el-tag @click="showImg(scope.row)">查看二维码</el-tag>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="plugA"
          label="插孔"
          width="330"
          align="center"
          :formatter="formatPlugB"
        >
          <template slot-scope="scope">
            <EquipmentStatusView :plugList="scope.row.plugList" :equipmentType="scope.row.equipmentType"/>
          </template>
        </el-table-column>

<!--        <el-table-column prop="plugB" label="插孔B" width="200" align="center">
          <template slot-scope="scope">
            <el-tag type="success">在线</el-tag>/<el-tag type="success"
              >空闲</el-tag
            >
          </template>
        </el-table-column> -->

<!--        <el-table-column
          prop="remark"
          label="描述"
          width="500"
          align="center"
        ></el-table-column> -->
        <el-table-column fixed="right" width="400" align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="showChargingDialog(scope.row)"
              >充电操作</el-button
            >
            <el-button @click="showImg(scope.row)">二维码</el-button>
            <el-button @click="createCode(scope.row.equipmentCode)"
              >重置二维码</el-button
            >
            <el-button @click="showEditEmpView(scope.row)">编辑</el-button>
            <el-button
              @click="deleteUser(scope.row)"
              type="danger"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex; justify-content: flex-end">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total, slot"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 表格 END -->

    <el-dialog
      :title="dialogImgTitle"
      :visible.sync="dialogImgVisible"
      width="300px"
    >
      <el-row>
        <div style="text-align: center">
          <span class="demonstration"
            ><h2>{{ currentViewCode }}</h2></span
          >
        </div>
      </el-row>
      <hr />
      <el-row>
        <div style="width: 95%; display: flex">
          <el-image :src="currentViewImg" width="100%"></el-image>
        </div>
      </el-row>
    </el-dialog>

    <el-dialog :title="title" :visible.sync="dialogVisible" width="1000px">
      <div>
        <el-form
          :model="form"
          :rules="formRules"
          ref="formRef"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="所属站点:" prop="stationId">
            <el-select
              style="width: 85%"
              filterable
              v-model="form.chargeStationId"
              placeholder="请选择"
              @change="stationIdChange"
            >
              <el-option
                v-for="item in stationIdOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="设备类型:" prop="equipmentType">
            <el-select
              style="width: 85%"
              v-model="form.equipmentType"
              placeholder="请选择"
              @change="equipmentTypeChange"
            >
              <el-option
                v-for="item in equipmentTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="网关:" prop="gatewayId" v-show="gatewayShow">
            <el-select
              style="width: 85%"
              v-model="form.gatewayId"
              placeholder="请选择"
              @change="gatewayOptionsChange"
            >
              <el-option
                v-for="item in gatewayOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="GatewayRemoteId:"
            prop="remoteGatewayId"
            style="display: none"
          >
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.remoteGatewayId"
              placeholder="请选择网关"
            ></el-input>
          </el-form-item>
          <el-form-item label="设备名称:" prop="equipmentName">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.equipmentName"
              placeholder="请输入桩名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="设备编码:" prop="equipmentCode">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.equipmentCode"
              placeholder="请输入设备编码"
            ></el-input>
          </el-form-item>
          <el-form-item label="IMEI码:" prop="imei">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.imei"
              placeholder="请输入IMEI码"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="MAC地址:"
            prop="macAddress"
            style="display: none"
          >
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.macAddress"
              placeholder="请输入MAC地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="插座数量:" prop="connectorNumber">
            <el-input
              type="number"
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.connectorNumber"
              placeholder="请输入插座数量"
            ></el-input>
          </el-form-item>

          <el-form-item label="建桩位置:" prop="address">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.address"
              placeholder="请输入建桩位置"
            ></el-input>
          </el-form-item>
          <el-form-item label="监控地址:" prop="monitorAddress">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.monitorAddress"
              placeholder="请输入监控地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="烟感:" prop="smokeDetector">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.smokeDetector"
              placeholder="请输入烟感"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注:" prop="remark">
            <el-input type="textarea" v-model="form.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="doAddUser">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="启动充电XXXXXXXXXXXXXXX"
      :visible.sync="dialogStartVisible"
      width="600px"
    >
      <el-row>
        <el-form :model="startParams">
          <el-form-item label="设备名称">
            <span>{{ startParams.equipmentName }}</span>
          </el-form-item>
          <el-form-item label="设备编号">
            <span>{{ startParams.pileNo }}</span>
          </el-form-item>
          <el-form-item label="插座接口：">
              <el-radio-group v-model="startParams.port" @change="changePort()">
                <el-radio style="margin-top: 12px;"
                  :label="item.port"
                  :key="item.port"
                  v-for="item in business.portStatusList"
                  >{{ item.name }}
                  <template v-if="item.status==1"> <el-link type="success">在线</el-link></template>
                  <template v-if="item.status==2"> <el-link type="danger">占用（充电桩）</el-link></template>
                  <template v-if="item.status==3">禁用</template>
				  <template v-if="item.status==4">故障</template>
				  <template v-if="item.status==5">离线</template>
                  </el-radio
                >
              </el-radio-group>
            </el-form-item>

             <el-form-item label="选择时长：">
              <!-- <el-radio-group v-model="startParams.value">
                <el-radio style="margin-top: 12px;"
                  :label="item.hour"
                  :key="item.hour"
                  v-for="item in business.feeVOList"
                  >{{ item.hour }} 小时</el-radio
                >
              </el-radio-group> -->
			  <el-radio-group v-model="startParams.value" @change="changeChargeTime()">
			    <el-radio style="margin-top: 12px;"
			      :label="item"
			      :key="item"
			      v-for="item in 10"
			      >{{ item }} 小时</el-radio
			    >
			  </el-radio-group>
            </el-form-item>
			<el-form-item>
				<span style="color: #999999;text-align:center">当前设备状态使用3.9充电协议</span>
			</el-form-item>
          <el-row>
            <el-col :span="12">
              &nbsp;
            </el-col>
             <el-col :span="12">
             <el-button @click="startCharging" type="primary" :disabled="startButtonCtrl">启动充电</el-button>
             </el-col>
            
          </el-row>
        </el-form>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteRequest,
  putRequest,
  getRequest,
  postRequest,
} from "../../utils/api";
import {
  apiListStations,
  apiListGatewayByStationId,
  apiListEquipmentsByStationId,
  apiListEquipments,
  apiCreateCode,
} from "./charge-equipment";
import EquipmentStatusView from './EquipmentStatusView.vue'
export default {
  name: "ChargeEquipmentList",
  components:{EquipmentStatusView},
  data() {
    return {
      startButtonCtrl:false,
      title: "", //模态窗口 标题
      searcheForm: {}, //搜索
      dialogStartVisible: false,
      startParams: {
        pileNo: null,
        equipmentName: null,
        port: null,
        openId: "system_admin",
        optType:1,
        totalMoney:0,
        outTradeNo:'system_admin_operations:start',
        value:1,
      },
      business: {
        equipmentCode: null,
        equipmentName: null,
        portStatusList: [],
        feeVOList:[],
      },
      users: [], //列表数据
      loading: false,
      dialogVisible: false, // 是否显示 模态窗口
      dialogImgVisible: false,
      currentViewImg: null,
      currentViewCode: null,
      stationIdOptions: [],
      gatewayOptions: [],
      qrcodeImgUrl: "",
      dialogImgTitle: "",
      total: 0,
      page: 1,
      size: 10,
      gatewayShow: false,
      viewImgList: [],
      form: {
        equipmentType: 1,
        remoteGatewayId: null,
        gatewayId: null,
      },
      equipmentTypeOptions: [
        { label: "独立设备", value: 1 },
        { label: "组网设备", value: 2 },
      ],
      formRules: {
        equipmentCode: [
          { required: true, message: "请输桩id", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        imei: [
          { required: true, message: "请输IMEI码", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 32 个字符",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "请输建桩位置", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 100 个字符",
            trigger: "blur",
          },
        ],
        equipmentName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
        macAddress: [
          { required: false, message: "请输入设备MAC码", trigger: "blur" },
        ],
        connectorNumber: [
          { required: true, message: "请输入插座数量", trigger: "blur" },
        ],
        remark: [{ required: false, message: "请填写备注", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.cyrrentViewCode = "";
    this.currentViewImg = "";
    this.listEquipments();
    this.initSelectStations();
  },
  methods: {
	changePort(){
		let item = this.business.portStatusList.find(item=> item.port===this.startParams.port);
		if(item.status==='1'){
			this.startButtonCtrl=false
		}else{
			this.startButtonCtrl=true
		}
	},
	changeChargeTime(){
	},
    showChargingDialog(row) {
      this.startButtonCtrl=false;
      this.dialogStartVisible = true;
      this.startParams.pileNo = row.equipmentCode;
      this.startParams.equipmentName=row.equipmentName;
      let qrcodeValue ="shhp.city/hpcd/?id="+row.equipmentCode;
      let params ={codeValue:qrcodeValue,openId:'system_admin',outTradeNo:'justify-user-non-systemctrl'};
      postRequest('/charging/qr-scan',params).then((resp)=>{
        if(resp.status==200){
          this.business=resp.data;
          let item  = this.business.portStatusList[0];
          if(item.status==2 || item.status==3){
            this.startButtonCtrl=true;
          }
        }
      })
    },
    startCharging() {
      console.log(JSON.stringify(this.startParams));
	  this.startParams.feeType=1
      postRequest('/charging/start',this.startParams).then((resp)=>{
        if(resp.status==200){
          this.$message({message:'执行成功',type:'success'});
        }
        if(!resp.status==200){
           this.$message({message:resp.msg,type:'error'});
        }
      })
    },
    stopCharging() {
      console.log(JSON.stringify(this.startParams));
    },
    createCode(code) {
      apiCreateCode(code).then((resp) => {
        this.$message({ message: "操作成功",type:'success' });
      });
    },
    showImg(row) {
      this.dialogImgVisible = true;
      this.currentViewImg = row.qrcodeImgUrl;
      this.currentViewCode = row.equipmentCode;
    },
    clearForm() {
      this.searcheForm = {};
    },
    formatGender(row, column) {
      return row.gender == "1" ? "男" : row.gender == "0" ? "女" : "";
    },
    imgFormatter(row, column, cellValue, index) {},
    formatEquipmentType(row, column, cellValue, index) {
      if (cellValue == 1) {
        return "独立设备";
      }
      if (cellValue == 2) {
        return "组网设备";
      }
    },
    formatPlugA(row, column, cellValue, index) {
      return "在线/空闲";
    },
    formatPlugB(row, column, cellValue, index) {
      return '在线/<el-tag type="success">标签二</el-tag>';
    },
    formatEnable(row, colum) {
      return row.enabled == true ? "是" : row.enabled == false ? "否" : "";
    },
    // 添加用户按钮
    showAddEmpView() {
      this.form = {};
      this.title = "新增";
      this.dialogVisible = true;
    },
    //编辑用户按钮
    showEditEmpView(data) {
      this.title = "编辑";
      this.form = data;
      this.dialogVisible = true;
    },
    // 删除用户
    deleteUser(data) {
      this.$confirm(
        "此操作将永久删除【" + data.equipmentName + "】, 是否继续?",
        "提示",
        { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" }
      )
        .then(() => {
          deleteRequest(`/api/chargeEquipment/delEquipment/${data.id}`).then(
            (resp) => {
              if (resp) {
                this.listEquipments();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //添加卡 && 更新卡信息
    doAddUser() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          let url = "";
          let res;
          if (this.form.id) {
            url = `/api/chargeEquipment/updateEquipment`;
            res = putRequest(url, this.form);
          } else {
            url = `/api/chargeEquipment/addEquipment`;
            res = postRequest(url, this.form);
          }
          res
            .then((resp) => {
              if (resp.status == 200) {
                Message.success({ message: "操作成功" });
              } else {
                Message.error({ message: resp.msg });
              }
              if (resp) {
                this.dialogVisible = false;
                this.listEquipments();
              }
            })
            .catch((e) => {});
        }
      });
    },
    // 页大小
    sizeChange(currentSize) {
      this.size = currentSize;
      this.listEquipments();
    },
    // 选择页
    currentChange(currentPage) {
      this.page = currentPage;
      this.listEquipments();
    },
	search(){
		this.page=1
		console.log('重置页码：'+this.page)
		this.listEquipments()
	},
    // 查询桩列表
    listEquipments(type) {
      this.loading = true;
      let form = this.searcheForm;
      form.page = this.page;
      form.size = this.size;
      form.page = this.page;
      form.size = this.size;
      apiListEquipments(form).then((resp) => {
        this.loading = false;
        if (resp) {
          this.users = resp.data.list;
          this.total = resp.data.total;
        }
      });
    },
    //
    changeGateway(stationId) {
      this.form.gatewayId = null;
      this.form.remoteGatewayId = null;
      this.form.remoteGatewaySn = null;
      apiListGatewayByStationId({ stationId: stationId ,size:999}).then((resp) => {
        if (resp.status == 200) {
          const data = resp.data.list;
          this.gatewayOptions = [];
          data.forEach((element) => {
            this.gatewayOptions.push({
              label: element.gatewayName + "-" + element.gatewayCode,
              value: element.id,
              remoteGatewayId: element.remoteGatewayId,
              remoteGatewaySn: element.gatewayCode,
            });
          });
        }
        this.form.gatewayId = this.gatewayOptions[0].value;
        this.form.remoteGatewayId = this.gatewayOptions[0].remoteGatewayId;
        this.form.remoteGatewaySn = this.gatewayOptions[0].remoteGatewaySn;
      });
    },
    gatewayOptionsChange(v) {
      const data = this.gatewayOptions;
      data.forEach((element) => {
        console.log(JSON.stringify(element));
        if (element.value == v) {
          this.form.remoteGatewayId = element.remoteGatewayId;
          this.form.remoteGatewaySn = element.remoteGatewaySn;
        }
      });
    },
    // 选择组网设备时加载网关信息
    equipmentTypeChange(v) {
      console.log(
        "设备类型" +
          v +
          "StationID" +
          this.stationId +
          " Form=" +
          this.form.stationId
      );
      if (v == 1) {
        this.gatewayShow = false;
        this.form.gatewayId = null;
        this.form.remoteGatewaySn = null;
        this.form.remoteGatewaySn = null;
      }
      if (v == 2) {
        this.gatewayShow = true;
        const stationId = this.form.chargeStationId;
        this.changeGateway(stationId);
      }
    },
    // 站点切换之后操作
    stationIdChange(v) {
      this.stationIdOptions.forEach((element) => {
        if (element.value == v) {
          console.log("站点远程平台ID" + element.remoteSiteId);
          this.form.remoteSiteId = element.remoteSiteId;
        }
      });
      console.log(
        "站点选择" + v + " 新增设备类型 ：" + this.form.equipmentType
      );
      if (this.form.equipmentType == 2) {
        this.changeGateway(v);
      }
    },
    initSelectStations() {
      apiListStations({page:1,size:999}).then((resp) => {
        if (resp.status == 200) {
          const data = resp.data;
          this.stationList = data.list;
          this.stationList.forEach((element) => {
            this.stationIdOptions.push({
              label: element.stationName,
              value: element.id,
              remoteSiteId: element.remoteSiteId,
            });
          });
        }
      });
    },
    //
  },
};
</script>

<style>
.page-body {
  margin-top: 30px;
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>